import React from 'react';
import PropTypes from 'prop-types';

export default (ComponentToConnect) => {
  return class Calculator extends React.Component {
    static propTypes = {
      plans: PropTypes.arrayOf(
        PropTypes.object
      )
    }
    constructor(props) {
      super(props);
      this.displayName = `Calculator(${ComponentToConnect.constructor.name})`;
    }
    render() {
      return (
        <div>
          <ComponentToConnect {...this.props} />
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/CalculatorHOC.js